var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4 1.59998H1.6C0.72 1.59998 0.00799999 2.31998 0.00799999 3.19998L0 12.8C0 13.68 0.72 14.4 1.6 14.4H14.4C15.28 14.4 16 13.68 16 12.8V3.19998C16 2.31998 15.28 1.59998 14.4 1.59998ZM1.6 5.59998H10V8.39998H1.6V5.59998ZM1.6 9.99998H10V12.8H2.4C1.96 12.8 1.6 12.44 1.6 12V9.99998ZM13.6 12.8H11.6V5.59998H14.4V12C14.4 12.44 14.04 12.8 13.6 12.8Z",
    fill: "#171923",
    fillOpacity: 0.87
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/Preview.e3da90bf440eec5aa39f2425bcecb2ad.svg";
export { ForwardRef as ReactComponent };